import { k as ensure_array_like, e as escape_html, b as attr, m as stringify, p as pop, a as push } from "../../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "../../../../../chunks/state.svelte.js";
function _page($$payload, $$props) {
  push();
  const { data } = $$props;
  const order = data?.order;
  const user = data?.order?.user;
  const productsOnOrder = data?.order?.ProductOnOrder || [];
  const formatDate = (date) => {
    return new Date(date).toLocaleString("en-UK", { day: "numeric", month: "short", year: "numeric" });
  };
  if (order) {
    $$payload.out.push("<!--[-->");
    const each_array = ensure_array_like(productsOnOrder);
    $$payload.out.push(`<main class="m-4 p-4"><h1 class="mb-4 text-4xl font-bold">Order Details</h1> <div class="mb-6"><h2 class="text-2xl font-semibold">User Information</h2> <p><strong>Name:</strong> ${escape_html(user?.name)}</p> <p><strong>Email:</strong> ${escape_html(user?.email)}</p> <p><strong>Order Date:</strong> ${escape_html(order ? formatDate(order.createdAt) : null)}</p> <p><strong>Total Price:</strong> KES ${escape_html(order?.totalPrice)}</p></div> <div><!--[-->`);
    for (let $$index = 0, $$length = each_array.length; $$index < $$length; $$index++) {
      let productOnOrder = each_array[$$index];
      $$payload.out.push(`<div class="mb-4 rounded-md border p-4 shadow-xs"><h3 class="text-xl font-semibold">${escape_html(productOnOrder.product.name)}</h3> <p><strong>Price:</strong> KES ${escape_html(productOnOrder.product.price)}</p> <p><strong>Quantity:</strong> ${escape_html(productOnOrder.quantity)}</p> <div class="flex items-center space-x-2"><label${attr("for", `issue-${stringify(productOnOrder.product.id)}`)}><strong>${escape_html(productOnOrder.isIssued ? "Issued" : "Issue")}</strong></label> <input type="checkbox"${attr("id", `issue-${stringify(productOnOrder.product.id)}`)}${attr("checked", productOnOrder.isIssued, true)} class="h-4 w-4"/></div></div>`);
    }
    $$payload.out.push(`<!--]--></div></main>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<div class="flex h-full items-center justify-center"><p class="text-4xl font-thin">No orders</p></div>`);
  }
  $$payload.out.push(`<!--]-->`);
  pop();
}
export {
  _page as default
};
